import { render } from "./AppSelect.vue?vue&type=template&id=060efe7b&scoped=true&ts=true"
import script from "./AppSelect.vue?vue&type=script&lang=ts"
export * from "./AppSelect.vue?vue&type=script&lang=ts"

import "./AppSelect.vue?vue&type=style&index=0&id=060efe7b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060efe7b"]])

export default __exports__